import { Component, HostListener, OnInit } from '@angular/core'
import { RestServices } from '../../../../services/rest.services'
import { AuthService } from '../../../../services/auth.services'
import { ModalService } from '../../../../services/modal.service'
import { FormBuilder, FormControl, Validators } from '@angular/forms'
import { SharedServices } from '../../../../services/shared.services'
import { onsNotification } from 'ngx-onsenui'
import { environment } from '../../../../../environments/environment'

@Component({
    selector: 'app-modal-profile-client',
    templateUrl: './profile-client.component.html',
    styleUrls: [
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/main-view.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class ProfileClientComponent implements OnInit {

    ModalNewClientDoctor = 'hidden'
    modalMail = 'hidden'
    listEmail
    listStaff
    selectedDoctor
    selectedCordinator
    modalSelected
    arraySelected = [{ role: '', id: '' }, { role: '', id: '' }]
    alertMail = true
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    routerLink
    filterCordinator
    filterDoctor
    listDoctor
    listCodinator
    statusEsc
    email = new FormControl('', [Validators.required])
    subject = new FormControl('', [Validators.required, Validators.maxLength(200)])
    body = new FormControl('', [Validators.required])
    idClient
    lang
    submit = false
    active: any = '';
    isAppointmentOrOptional: boolean = false
    appointmentOrOptionalReceiver: any = {}
    appointmentOrOptionalSetting: any = {}

    constructor(private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private _sharedService: SharedServices,
                private modalService: ModalService) {
        this.modalService.changeEmitted$.subscribe(
            success => {
                this.active = success[0];
                if (success[0] === 'activeModalDoctorProfile') {
                    this.ModalNewClientDoctor = 'active'
                    this.statusEsc = true
                } else if (success[0] === 'activeModalMailProfile' || success[0] === 'activeModalMailProfileNew') {
                    this.modalMail = 'active'
                    this.listEmail = success[1]
                    this.email.setValue(this.listEmail[0])
                    this.idClient = success[2]
                    this.langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
                    this.statusEsc = true

                } else if (success[0] === 'activeModalAppointmentMail' || success[0] === 'activeModalOptionalMail') {
                    this.modalMail = 'active'
                    this.appointmentOrOptionalReceiver = success[1]
                    this.idClient = success[2]
                    this.langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
                    this.statusEsc = true
                    this.isAppointmentOrOptional = true
                    if (success[3]) {
                        this.appointmentOrOptionalSetting = success[3]
                        if (success[3]['setting'] && success[3]['setting']['title']) {
                            this.subject.setValue(success[3]['setting']['title'])
                        }
                        if (success[3]['setting']&& success[3]['setting']['html']) {
                            this.body.setValue(success[3]['setting']['html'])
                        } else if (success[3]['setting'] && success[3]['setting']['text']) {
                            this.body.setValue(success[3]['setting']['text'])
                        }
                    }
                }
                if (success[1] === 'cordinator') {
                    this.listStaff = success[3]
                    this.listCodinator = this.listStaff
                    this.modalSelected = 'cordinator'
                    if (success[5]) {
                        this.selectedCordinator = success[5]
                    }
                    if (this.listCodinator) {
                        this.listCodinator.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                    }
                } else if (success[1] === 'doctor') {
                    this.listStaff = success[2]
                    this.listDoctor = this.listStaff
                    if (this.listDoctor) {
                        this.listDoctor.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                    }
                    this.modalSelected = 'doctor'
                    if (success[4]) {
                        this.selectedDoctor = success[4]
                    }
                }
                // if (success === 'activeAlertNewClientPage') {
                //     this.alertMail = false;
                //     this.alertLanguage();
                // }
                if (success && success[0] === 'checkRotesLink') {
                    this.routerLink = success[1]
                }
                //
            })
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        if (this.statusEsc) {
            if (keyPressed === 27) {
                this.hidenModalNewClientListDoctor()
            }
        }
    }

    // hiden modal
    hidenModalNewClientListDoctor() {
        this.ModalNewClientDoctor = 'hidden'
        this.statusEsc = false
    }

    hiddenModalMail() {
        this.modalMail = 'hidden'
        this.statusEsc = false
        this.email.setValue('')
        this.subject.setValue('')
        this.body.setValue('')
        this.submit = false
        this.isAppointmentOrOptional = false
        this.appointmentOrOptionalReceiver = {}
        this.appointmentOrOptionalSetting = {}
    }

    // search
    search(option) {
        if (option === 'doctor') {
            if (this.filterDoctor !== '') {
                const searchResult = this.listStaff.filter(staff => ((staff.firstName ? staff.firstName.indexOf(this.filterDoctor) !== -1 : false) || (staff.familyName ? staff.familyName.indexOf(this.filterDoctor) !== -1 : false)))
                //
                if (searchResult) {
                    this.listDoctor = searchResult
                    // this.listDoctor.push(searchResult);
                } else {
                    this.listDoctor = []
                }
            } else {
                this.listDoctor = this.listStaff
            }
            if (this.listDoctor) {
                this.listDoctor.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
            }
        }
        if (option === 'cordinator') {
            if (this.filterCordinator !== '') {
                const searchResult = this.listStaff.filter(staff => ((staff.firstName ? staff.firstName.indexOf(this.filterCordinator) !== -1 : false) || (staff.familyName ? staff.familyName.indexOf(this.filterCordinator) !== -1 : false)))
                if (searchResult) {
                    //
                    this.listCodinator = searchResult
                    // this.listCodinator.push(searchResult);
                    //
                } else {
                    this.listCodinator = []
                }
            } else {
                this.listCodinator = this.listStaff
            }
            if (this.listCodinator) {
                this.listCodinator.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
            }
        }
    }

    ngOnInit() {
    }

    selectDoctor(index) {
        if (this.modalSelected === 'cordinator') {
            this.selectedCordinator = index
            this.ModalNewClientDoctor = 'hidden'
            this.arraySelected[1] = { role: 'cordinator', id: this.selectedCordinator }
        } else if (this.modalSelected === 'doctor') {
            this.selectedDoctor = index
            this.ModalNewClientDoctor = 'hidden'
            this.arraySelected[0] = { role: 'doctor', id: this.selectedDoctor }
        }
        //
        this._sharedService.emitChangeParent(this.arraySelected)
    }

    changeLanguage() {
        return this.lang = this.authData.showLang(true)
    }

    sendMail() {
        this.submit = true
        if (!this.isAppointmentOrOptional) {
            this.sendProfileRegistrationMail()
        } else if (this.appointmentOrOptionalSetting['type'] === 'appoint') {
            this.sendAppointmentMail()
        } else if (this.appointmentOrOptionalSetting['type'] === 'optional') {
            this.sendOptionalMail()
        }
    }

    sendProfileRegistrationMail() {
        if (this.email.value && this.subject.value && this.body.value) {
            onsNotification.confirm(
                {
                    message: this.langDefault === 'false' ? '面談日程・写真撮影依頼メール送信<br>本当にメールを送りますか？' : 'Are you sure you want to send email?',
                    title: '',
                    buttonLabels: [this.langDefault === 'false' ? '戻る' : 'Cancel', this.langDefault === 'false' ? 'OK' : 'OK'],
                    // modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.
                            const data = {
                                client_id: this.idClient,
                                toolUploadUrl: environment.toolUploadUrl,
                                email: this.email.value,
                                subject: this.subject.value,
                                body: this.body.value,
                                lang: this.langDefault === 'false' ? 'jp' : 'en',
                            }
                            this.authData.authToken().then(tokenReNew => {
                                this.restApi.http_post('online-consultation/mail', data, tokenReNew).subscribe(success => {
                                    this.modalMail = 'hidden'
                                    this.statusEsc = false
                                    this.email.setValue('')
                                    this.subject.setValue('')
                                    this.body.setValue('')
                                })
                            })
                        } else {
                            // this.modalMail = 'hidden';
                            // this.statusEsc = false;
                        }
                    },
                })
        }
    }

    sendAppointmentMail() {
        if (this.appointmentOrOptionalReceiver['email'] && this.subject.value && this.body.value) {
            onsNotification.confirm(
                {
                    message: this.lang['client-detail-profile-confirm-appoint-mail-message'],
                    title: '<b>' + this.lang['client-detail-profile-confirm-appoint-mail-title'] + '</b>',
                    buttonLabels: [this.lang['client-detail-profile-confirm-submit-lable-cancel'], this.lang['client-detail-profile-confirm-submit-lable-ok']],
                    modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {
                            const resourceUrl = 'resource'
                            const clientIdParam = '{"clientId":"' + [this.idClient] + '"}'
                            const resourceData = {
                                actions: [
                                    {
                                        collection: 'clientMail',
                                        type: 'create',
                                        value: {
                                            'clientId': this.idClient,
                                            'data': {
                                                'mailNo': this.appointmentOrOptionalReceiver['mailNo'],
                                            },
                                            'status': 'reserved',
                                            'type': this.appointmentOrOptionalSetting['type'],
                                            'template': {
                                                'title': this.subject.value || this.appointmentOrOptionalSetting['setting']['title'] || '',
                                                'html': (this.body.value as string).replace(/\n/g, '<br>'),
                                                'text': this.appointmentOrOptionalSetting['setting']['text'] || '',
                                            },
                                        },
                                    },
                                ],
                                status: {
                                    client: {
                                        paths: { [clientIdParam]: true },
                                    },
                                    clinic: {
                                        paths: {
                                            '{}': true,
                                        },
                                    },
                                    setting: {
                                        map: {
                                            common: true,
                                        },
                                        paths: {
                                            '{}': true,
                                        },
                                    },
                                    staff: {
                                        paths: {
                                            '{"roles":"cordinator"}': true,
                                            '{"roles":"doctor"}': true,
                                            '{}': true,
                                        },
                                    },
                                },
                            }
                            this.authData.authToken().then(tokenReNew => {
                                this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                                    _ => {
                                        this.hiddenModalMail()
                                    },
                                )
                            })
                        }
                    },
                })
        }
    }

    sendOptionalMail() {
        if (this.appointmentOrOptionalReceiver['email'] && this.subject.value && this.body.value) {
            onsNotification.confirm(
                {
                    message: this.lang['client-detail-profile-confirm-optional-mail-message'],
                    title: '<b>' + this.lang['client-detail-profile-confirm-optional-mail-title'] + '</b>',
                    buttonLabels: [this.lang['client-detail-profile-confirm-submit-lable-cancel'], this.lang['client-detail-profile-confirm-submit-lable-ok']],
                    modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {
                            const resourceUrl = 'resource'
                            const clientIdParam = '{"clientId":"' + [this.idClient] + '"}'
                            const resourceData = {
                                actions: [
                                    {
                                        collection: 'clientMail',
                                        type: 'create',
                                        value: {
                                            'clientId': this.idClient,
                                            'data': {
                                                'mailNo': this.appointmentOrOptionalReceiver['mailNo'],
                                            },
                                            'status': 'reserved',
                                            'type': this.appointmentOrOptionalSetting['type'],
                                            'template': {
                                                'title': this.subject.value || this.appointmentOrOptionalSetting['setting']['title'] || '',
                                                'html': (this.body.value as string).replace(/\n/g, '<br>'),
                                                'text': this.appointmentOrOptionalSetting['setting']['text'] || '',
                                            },
                                        },
                                    },
                                ],
                                status: {
                                    client: {
                                        paths: { [clientIdParam]: true },
                                    },
                                    clinic: {
                                        paths: {
                                            '{}': true,
                                        },
                                    },
                                    setting: {
                                        map: {
                                            common: true,
                                        },
                                        paths: {
                                            '{}': true,
                                        },
                                    },
                                    staff: {
                                        paths: {
                                            '{"roles":"cordinator"}': true,
                                            '{"roles":"doctor"}': true,
                                            '{}': true,
                                        },
                                    },
                                },
                            }
                            this.authData.authToken().then(tokenReNew => {
                                this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                                    _ => {
                                        this.hiddenModalMail()
                                    },
                                )
                            })
                        }
                    },
                })
        }
    }

    sendMailUpdateProfile() {
        this.submit = true
        if (this.email.value && this.subject.value && this.body.value && this.subject.value.length <= 200) {
            onsNotification.confirm(
                {
                    // message: this.langDefault === 'false' ? 'プロフィール登録依頼メール送\n信本当にメールを送りますか？' : 'Are you sure you want to send email?',
                    messageHTML: this.langDefault === 'false' ? '<b>プロフィール登録依頼メール送信</b><br><p>本当にメールを送りますか？</p>' : 'Are you sure you want to send email?',
                    title: '',
                    buttonLabels: [this.langDefault === 'false' ? '戻る' : 'Cancel', this.langDefault === 'false' ? 'OK' : 'OK'],
                    // modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.
                            const data = {
                                client_id: this.idClient,
                                toolUpdateProfileUrl: environment.toolUpdateProfileUrl,
                                email: this.email.value,
                                subject: this.subject.value,
                                body: this.body.value,
                                lang: this.langDefault === 'false' ? 'jp' : 'en',
                            }
                            if(this.subject.value.length <= 200){
                                this.authData.authToken().then(tokenReNew => {
                                    this.restApi.http_post('sign-up-remote-profile/send-profile-mail', data, tokenReNew).subscribe(success => {
                                        this.modalMail = 'hidden'
                                        this.statusEsc = false
                                        this.email.setValue('')
                                        this.subject.setValue('')
                                        this.body.setValue('')
                                    })
                                })
                            }
                            
                        } else {
                            // this.modalMail = 'hidden';
                            // this.statusEsc = false;
                        }
                    },
                })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client/profile-client/profile-client.component.ts